import { NavLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import LanguageToggle from "./LanguageToggle";

export default function Header() {
  const { t } = useLanguage();

  return (
    <>
      <header className="fixed top-0 right-0 z-40 px-16 py-8 flex gap-10 text-xs tracking-widest uppercase text-neutral-300">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? "text-white" : "hover:text-white transition"
          }
        >
          {t.nav.home}
        </NavLink>

        <NavLink
          to="/projects"
          className={({ isActive }) =>
            isActive ? "text-white" : "hover:text-white transition"
          }
        >
          {t.nav.projects}
        </NavLink>

        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive ? "text-white" : "hover:text-white transition"
          }
        >
          {t.nav.contact}
        </NavLink>

        <LanguageToggle />
      </header>
    </>
  );
}
